import { extendTheme } from '@chakra-ui/react';

const customTheme = extendTheme({
  styles: {
    global: {
      '*': {
        WebkitTapHighlightColor: 'transparent',
      },
    },
  },
  components: {
    Checkbox: {
      baseStyle: {
        control: {
          _checked: {
            bg: 'var(--sutter-sync-primary, #5F1B93)',
            borderColor: 'var(--sutter-sync-primary, #5F1B93)',
            color: 'white',
          },
          _hover: {
            bg: 'var(--vibrant-purple, #A12EFF)',
            borderColor: 'var(--vibrant-purple, #A12EFF)',
          },
          _disabled: {
            bg: 'gray.100',
            borderColor: 'gray.300',
            color: 'gray.400',
          },
        },
      },
    },
    Progress: {
      baseStyle: {
        filledTrack: {
          bg: '#5F1B93',
        },
      },
      defaultProps: {
        colorScheme: "SutterSyncPurple",
      },
    },
    Input: {
      variants: {
        'input-grid': {
          field: {
            width: '165px',
            height: '48px',
            borderRadius: '6px',
            border: '2px solid #5F1B93',
            borderColor: '#5F1B93',
            padding: '15px 16px',
            _focus: {
              borderColor: '#5F1B93',
              boxShadow: '0 0 0 1px #5F1B93',
            },
            _hover: {
              borderColor: '#5F1B93',
            },
          },
        },
        'input-single': {
          field: {
            width: '100%',
            height: '48px',
            borderRadius: '6px',
            border: '2px solid #5F1B93',
            borderColor: '#5F1B93',
            padding: '15px 16px',
            _focus: {
              borderColor: '#5F1B93',
              boxShadow: '0 0 0 1px #5F1B93',
            },
            _hover: {
              borderColor: '#5F1B93',
            },
          },
        },
      },
    },
    NumberInput: {
      variants: {
        'input-grid': {
          field: {
            width: '100%',
            height: '48px',
            borderRadius: '6px',
            border: '2px solid #5F1B93',
            borderColor: '#5F1B93',
            padding: '15px 16px',
            _focus: {
              borderColor: '#5F1B93',
              boxShadow: '0 0 0 1px #5F1B93',
            },
            _hover: {
              borderColor: '#5F1B93',
            },
          },
        },
        'input-single': {
          field: {
            width: '100%',
            height: '48px',
            borderRadius: '6px',
            border: '2px solid #5F1B93',
            borderColor: '#5F1B93',
            padding: '15px 16px',
            _focus: {
              borderColor: '#5F1B93',
              boxShadow: '0 0 0 1px #5F1B93',
            },
            _hover: {
              borderColor: '#5F1B93',
            },
          },
        },
      },
    },
  },
  colors: {
    SutterSyncPurple: {
      50: '#EDE7F6',
      100: '#F4EEFD',
      200: '#B39DDB',
      300: '#9575CD',
      400: '#F1E0FF',
      500: '#A12EFF',
      600: '#5F1B93',
      700: '#340B54',
      800: '#4527A0',
      900: '#311B92',
    }
  },
});

export default customTheme;